export default "__VITE_ASSET__CNFnx_pC__"